import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { OrderReturnsRoutingModule } from './order-return-routing.module'
import { OrderReturnsListComponent } from './pages/order-returns-list/order-returns-list.component'
import { OrderReturnDetailsComponent } from './pages/order-return-details/order-return-details.component'
import { SharedModule } from 'src/app/shared/shared.module'
import { OrderReturnTableComponent } from './components/order-returns-table.component'

@NgModule({
	declarations: [OrderReturnsListComponent,  OrderReturnDetailsComponent , OrderReturnTableComponent],
	imports: [CommonModule, OrderReturnsRoutingModule, SharedModule],
})
export class OrderReturnModule {}